<template>
  <div id="app">
    <Loader v-if="isLoading"/>
    <router-view/>
    <DocumentComplianceModal />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {Loader} from 'wize-admin'
import DocumentComplianceModal from '@/core/components/DocumentComplianceModal.vue'

export default {
  mounted() {
    document.documentElement.style.setProperty('--color-primary', '#0288D1')
    document.documentElement.style.setProperty('--color-primary-dark', '#01579B')
  },
  components: {
    Loader,
    DocumentComplianceModal,
  },
  computed: {
    ...mapGetters({
      isLoading: 'app/isLoading'
    })
  }
}
</script>

<style>
</style>
